// @ts-ignore
import assign from 'assign-deep'

export function createGraphic(info:IGraphicOptions):IGraphicOptions {
    return assign({}, getBaseOptions(), info)
}

export function createTreeMapGraphic(info:IGraphicOptions = {}):IGraphicOptions {
    return assign({}, getBaseOptions(), info, {
        chart: {
            margin: 0,
            height: 450,
        },
        plotOptions: {
            series: {
                turboThreshold: 0,
            },
        },
        series: [
            {
                type: 'treemap',
                layoutAlgorithm: 'squarified',
                allowDrillToNode: true,
                animationLimit: 500,
                dataLabels: {
                    enabled: false
                },
                levelIsConstant: false,
                levels: [{
                    level: 1,
                    dataLabels: {
                        enabled: true
                    },
                    borderWidth: 3
                }],
            },
        ]
    })
}

function getBaseOptions():IGraphicOptions {
    return {
        chart: {
            events: {
                load() {
                    // @ts-ignore
                    this.showLoading();
                },
                redraw() {
                    // @ts-ignore
                    this.hideLoading();
                },
            },
        },
        title: {
            text: ''
        },
        xAxis: {
            title: {
                text: ''
            },
        },
        yAxis: {
            tickLength: 0,
            // sem linha de eixo nem grade; 'transparent' (e nao a cor do fundo) para valer nos dois temas
            lineColor: 'transparent',
            gridLineColor: 'transparent',
            title: {
                text: ''
            },
        },    
        credits: {
            enabled: false,
        },
        legend: {
            enabled: false
        },
    }
}

interface IGraphicOptions {
    [key:string]:any
}
